import type { Section } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import { query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions } from '../../../lib/json-api.ts';

export function querySections(clientId: string) {
  return query<Section>(
    DataTypeContent.Section,
    {
      'filter[client.id]': clientId,
      sort: 'title',
    },
    jsonApiOptions
  );
}
